import { useTranslation } from "react-i18next";
import i18n from "../translation";

// Content remains readable in English at its source. Translate only rendered
// text, so routes, form values, state identifiers, and analytics stay stable.
export function translateSiteText<T>(value: T): T {
  if (typeof value !== "string" || !value.trim()) return value;
  const key = value.trim();
  const translated = i18n.t(key, {
    ns: "site",
    nsSeparator: false,
    defaultValue: key,
  });
  return (value.slice(0, value.indexOf(key)) +
    translated +
    value.slice(value.indexOf(key) + key.length)) as unknown as T;
}

export function useSiteText() {
  // Subscribe every content component to language changes, including lazy pages.
  useTranslation("site");
  return translateSiteText;
}
